import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { faCheck, faCircleInfo, faDatabase, faXmark } from '@fortawesome/free-solid-svg-icons';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { CustomerDataService } from 'src/app/services/customer-data.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { RestService } from 'src/app/services/rest.service';
import { solarConfigSheets, windConfigSheets } from 'src/app/services/utils';

interface ColumnItem {
  key: string;
  sortFn: NzTableSortFn<any> | null;
  sortDirections: NzTableSortOrder[];
  sortOrder: NzTableSortOrder | null;
}
@Component({
  selector: 'app-update-config',
  templateUrl: './update-config.component.html',
  styleUrls: ['./update-config.component.scss']
})
export class UpdateConfigComponent implements OnInit {
  public url: any;
  public siteId: any;
  public companyId: any;
  public sitedata: any[] = [];
  public sitename: any = [];
  objectKeys = Object.keys;
  public visible: any = false;
  solarDetails!: boolean;


  faCheckIcon = faCheck;
  faCloseIcon = faXmark;
  faInfoCircleIcon = faCircleInfo;
  faDatabaseIcon = faDatabase;
  // validateForm!: UntypedFormGroup;
  enableBtn = false;
  siteConfig: any = {};
  siteName = '';
  configSheets: any[] = []// JSON.parse(JSON.stringify(solarConfigSheets));
  isLoading = false;
  isAdmin = false;
  enableCMMS = false;
  userId = '';
  showUpdateSchemaBtn = false;
  selectAllValidated = false;
  isValidatingAll = false;
  constructor(private activateroute: ActivatedRoute,
    private route: Router,
    private restService: RestService,
    private firebase: FirebaseService,
    private notification: NzNotificationService,
    private cdService: CustomerDataService) { }

  ngOnInit(): void {
    this.cdService.userId$.subscribe(id => {
      if (id === "sai@digitised.energy" || id === "ashok@digitised.energy") {
        this.showUpdateSchemaBtn = true;
      } else {
        this.showUpdateSchemaBtn = false;
      }
      this.userId = id
    });
    this.activateroute.paramMap.subscribe((params: ParamMap) => {
      const id = params.get('id');
      this.siteId = id;
    });
    this.url = this.route.url;
    // console.log(this.url.split('/'), 'this.url.split()')
    this.companyId = this.url.split('/')[2];
    this.cdService.role$.subscribe(role => { this.isAdmin = (role === 'admin') });
    //this.siteId = this.url.split('/')[3];
    this.onInit();
    setTimeout(() => { this.visible = true; }, 800);

  }
  async onInit() {
    await this.getSiteConfig()
  }
  async getSiteConfig() {
    this.isLoading = true;
    // this.sheets = [];
    const customer = this.companyId;//'dummy'//
    const siteId = this.siteId //'s1'//
    this.siteConfig = await this.firebase.getSiteConfig(customer, siteId);
    if (this.siteConfig) {
      this.siteName = this.siteConfig?.static_data?.name?.value//this.siteConfig.static_data[0].value;
    }
    if (this.siteConfig.type === 'solar') {
      this.configSheets = JSON.parse(JSON.stringify(solarConfigSheets));
    } else {
      this.configSheets = JSON.parse(JSON.stringify(windConfigSheets));
    }
    //windConfigSheets
    //configSheets: any[] =[]// JSON.parse(JSON.stringify(solarConfigSheets));

    for (const key in this.siteConfig.sheets) {
      if (Object.prototype.hasOwnProperty.call(this.siteConfig.sheets, key)) {
        const sheet: any = this.siteConfig.sheets[key];
        const objIndex = this.configSheets.findIndex(s => s.id === key);
        if (objIndex !== -1) {
          this.configSheets[objIndex] = { ...this.configSheets[objIndex], ...sheet }
        }
      }
    }
    /* console.log(this.siteConfig.id, this.siteId, 'this.siteId')
    console.log(this.siteConfig.sheets, 'this.this.siteConfig.sheets')
    console.log(this.configSheets, 'this.configSheets') */
    this.validateConfig();
    this.isLoading = false;

  }

  close(): void {
    this.visible = false;
    this.route.navigate([`/customers/${this.companyId}`], { relativeTo: this.activateroute });
  }
  submitForm() {
    // console.log('submit', this.sheets);
    this.isLoading = true;
    const sheets = this.configSheets.filter((s: any) => s.isChecked).map((fs) => fs.id);
    const customer = this.companyId;
    const id = this.siteId;
    this.restService.postMethod(this.restService.urls.updateConfig, {
      id,
      customer,
      sheets
    }).subscribe(
      {
        next: async (res: any) => {
          if (res.status === 'success') {
            //this.configSheets = JSON.parse(JSON.stringify(solarConfigSheets));
            await this.getSiteConfig();
            // if (this.siteConfig.type === 'solar') {
            //   this.configSheets = JSON.parse(JSON.stringify(solarConfigSheets));
            // } else {
            //   this.configSheets = JSON.parse(JSON.stringify(windConfigSheets));
            // }
            this.showNotifcation('success', 'Success', 'Site Config Updated Successfully')
          } else {
            // console.log(res, 'some error')
            this.showNotifcation('error', 'Error', 'Failed To Update Site Config. Try Again')
          }
          this.isLoading = false;
        },
        error: (e: any) => {
          this.isLoading = false;
          console.log(e, 'error');
          this.showNotifcation('error', 'Error', 'Something Went Wrong. Try Again')
        }
      }
    )
  }
  /* validateItem(control: string) {
    this.validateForm.controls[control].setValue(true)
  } */
  checkChange() {
    this.validateConfig()
  }
  hasValidSheets(): boolean {
    return !!this.configSheets?.some((sheet: any) => sheet.valid && sheet.redo);
  }
  toggleSelectAllValidated(): void {
    const validSheets = this.configSheets.filter((sheet: any) => sheet.valid && sheet.redo);
    validSheets.forEach((sheet: any) => {
      sheet.isChecked = this.selectAllValidated;
    });
    this.validateConfig();
  }
  validateConfig() {
    //console.log(this.configSheets)
    const validSheets = this.configSheets.filter((s) => s.valid && s.redo);
    this.selectAllValidated = validSheets.length > 0 && validSheets.every((s) => s.isChecked);

    const isValid = this.configSheets.every((s) => s.valid);
    let isChecked = false;
    if (this.siteConfig && this.siteConfig.updated) {
      isChecked = this.configSheets.some((s) => s.isChecked)
    } else {
      isChecked = this.configSheets.every((s) => s.isChecked)

    }
    this.enableBtn = isValid && isChecked;
    this.enableCMMS = !!this.configSheets.find((s) => s.id === "master" && s.valid && s.isChecked);

  }
  async validateAllSheets(): Promise<void> {
    if (this.isValidatingAll || !this.isAdmin) {
      return;
    }

    this.isValidatingAll = true;
    this.isLoading = true;

    try {
      for (const sheet of this.configSheets) {
        await this.validateSheet(sheet);
      }
      this.showNotifcation('success', 'Success', 'All sheets validated successfully');
    } finally {
      this.isValidatingAll = false;
      this.isLoading = false;
      this.validateConfig();
    }
  }
  validateSheet(sheet: any): Promise<void> {
    //sheet.valid = true
    const customer = this.companyId //'dummy'
    const id = this.siteId //'s1'
    this.isLoading = true;

    return new Promise((resolve) => {
      this.restService.postMethod(this.restService.urls.validateSheet, {
        id,
        customer,
        'sheet': sheet.id
      }).subscribe(
        {
          next: (res: any) => {
            if (res.status === 'success') {
              //console.log(res.message, 'res data success');
              this.configSheets.forEach((s) => {
                if (s.id === sheet.id) {
                  s.redo = true;
                  s.valid = true;
                  //s.isChecked = true;
                }
              })
              this.showNotifcation('success', 'Success', `${sheet.name} validated successfully`)
              // this.validateForm.controls[sheet.id].setValue(true)
            } else {
              // console.log(res)
              this.showNotifcation('error', 'Error', `${sheet.name} validation failed. Try again.`)
              this.configSheets.forEach((s) => {
                if (s.id === sheet.id) {
                  s.redo = false;
                  s.valid = false;
                }
              })

            }
            this.validateConfig();
            this.isLoading = false;
            resolve();
          },
          error: (e: any) => {
            console.log(e, 'error');
            this.showNotifcation('error', 'Error', `${sheet.name} validation failed. Something went wrong.`)
            this.isLoading = false;
            resolve();
          }
        }
      )
    });
  }

  updateSchema(sheet: any) {
    //sheet.valid = true
    const customer = this.companyId //'dummy'
    const id = this.siteId //'s1'
    this.isLoading = true;

    this.restService.postMethod(this.restService.urls.updateSchema, {
      id,
      customer,
      'sheet': sheet.id
    }).subscribe(
      {
        next: (res: any) => {
          if (res.status === 'success') {
            //console.log(res.message, 'res data success');
            this.configSheets.forEach((s) => {
              if (s.id === sheet.id) {
                s.redo = true;
                s.valid = true;
                //s.isChecked = true;
              }
            })
            this.showNotifcation('success', 'Success', 'Updated Schema Successfully')
            // this.validateForm.controls[sheet.id].setValue(true)
          } else {
            // console.log(res)
            this.showNotifcation('error', 'Error', 'Schema Update Failed. Try Again')
            this.configSheets.forEach((s) => {
              if (s.id === sheet.id) {
                s.redo = false;
                s.valid = false;
              }
            })

          }
          this.validateConfig();
          this.isLoading = false;
        },
        error: (e: any) => {
          console.log(e, 'error');
          this.showNotifcation('error', 'Error', 'Something Went Wrong')
          this.isLoading = false;
        }
      }
    )
  }

  updateCMMS() {

    this.isLoading = true;

    this.restService.postMethod(this.restService.urls.updateCMMS, {
      site_id: this.siteId,
      c_id: this.companyId,
    }).subscribe(
      {
        next: (res: any) => {
          if (res.status === 'success') {
            //console.log(res.message, 'res data success');

            this.showNotifcation('success', 'Success', 'CMMS Updated Successfully')
            // this.validateForm.controls[sheet.id].setValue(true)
          } else {
            // console.log(res)
            const msg = res.msg ? res.msg : 'CMMS Updation Failed. Try Again'
            this.showNotifcation('error', 'Error', msg)


          }
          this.validateConfig();
          this.isLoading = false;
        },
        error: (e: any) => {
          console.log(e, 'error');
          this.showNotifcation('error', 'Error', 'Something Went Wrong')
          this.isLoading = false;
        }
      }
    )
  }
  showNotifcation(type: string, title: string, msg: string) {
    this.notification.create(
      type,
      title,
      msg
    );
  }

}


